<template>
    <el-container style="width:100%">
        <el-header style="height:7%">
            <el-form>
                <el-row>
                    <el-col :span="24">
                        <el-form-item style="margin-left:5px;">
                            <td-button type="primary" :permissions="permissionsView" :loading="loading" @click="btnQuery">{{ $t('pgCommon.MY_WORK_FLOW') }}</td-button>

                            <td-button type="primary" :permissions="permissionsView" :loading="loading" @click="hisTaskQuery">{{ $t('pgCommon.COMPLETED') }}</td-button>

                            <td-button type="primary" :permissions="permissionsView" :loading="loading" @click="applyQuery">{{ $t('pgCommon.APPLIED') }}</td-button>

                            <td-button type="primary" :permissions="permissionsView" :loading="loading" @click="invoQuery">{{ $t('pgCommon.JOINED') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :permissions="permissionsView"
                ref="leaveBill"
                :hasPage="false"
                :dataSource="tableData"
                :pageSize="pageSize"
                :hasMutiSelect="false"
                :currentPage="currentPage"
                :total="total"
                :rowKey="rowKey"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-leaveBill
                v-if="dialogLeaveBillVisible"
                :dialogLeaveBillVisible="dialogLeaveBillVisible"
                :editItem="editItem"
                :title="title"
                :sIdDisabled="sIdDisabled"
                @dialogLeaveBillClose="dialogLeaveBillClose"
            ></dialog-leaveBill>

            <!-- <dialog-leaveBillPic
                v-if="dialogLeaveBillPicVisible"
                :dialogLeaveBillPicVisible="dialogLeaveBillPicVisible"
                :param="param"
                :title="title"
                @dialogLeaveBillPicClose="dialogLeaveBillPicClose"
            ></dialog-leaveBillPic> -->
        </el-main>
    </el-container>
</template>

<script>
import Api from './assets/api.js';
import dialogLeaveBill from './components/workFlowLeaveApprove.vue';
// import dialogLeaveBillPic from './components/dialogLeaveBillPic.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-leaveBill': dialogLeaveBill
        // 'dialog-leaveBillPic': dialogLeaveBillPic
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.btnQuery();
    },
    // 定义数据
    data() {
        return {
            permissionsView: ['workflow:view'],
            permissionsEdit: ['workflow:edit'],
            permissionsAdd: ['workflow:add'],
            tableData: [],
            rowKey: 'taskId',
            // isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            editItem: '',
            param: '',
            loading: false, // 按钮是否为加载状态
            dialogLeaveBillVisible: false,
            editDialog: false
            // dialogLeaveBillPicVisible: false
        };
    },
    // 方法的实现
    methods: {
        // 查询数据
        btnQuery() {
            this.loading = true;
            // this.currentPage = 1;
            this.queryList();
        },
        queryList() {
            this.columns = [
                {
                    prop: 'processId',
                    label: this.$t('pgCommon.WORK_FLOW_CODE'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'templateKey',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFKEY'),
                    sortable: true
                },
                {
                    prop: 'proDefName',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFNAME'),
                    sortable: true
                },
                {
                    prop: 'taskId',
                    align: 'left',
                    label: this.$t('pgCommon.TASK_ID'),
                    sortable: true
                },
                {
                    prop: 'taskKey',
                    label: this.$t('pgCommon.TASK_KEY'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'taskName',
                    label: this.$t('pgCommon.TASK_NAME'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.CHECK')
                            )
                        ]);
                    }
                }
            ];
            let param = {
                userId: sessionStorage.getItem('userId'),
                roleIds: sessionStorage.getItem('roles').split(','),
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                isNeedPage: false
            };
            Api.findTask(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.loading = false;
                    this.$log.error('/activitiDemo/findTask', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        hisTaskQuery() {
            this.loading = true;
            this.columns = [
                {
                    prop: 'processId',
                    label: this.$t('pgCommon.WORK_FLOW_CODE'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'templateKey',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFKEY'),
                    sortable: true
                },
                {
                    prop: 'proDefName',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFNAME'),
                    sortable: true
                },
                {
                    prop: 'taskId',
                    align: 'left',
                    label: this.$t('pgCommon.TASK_ID'),
                    sortable: true
                },
                {
                    prop: 'taskKey',
                    label: this.$t('pgCommon.TASK_KEY'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'taskName',
                    label: this.$t('pgCommon.TASK_NAME'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnShow(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.CHECK')
                            )
                        ]);
                    }
                }
            ];
            let param = {
                userId: sessionStorage.getItem('userId'),
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                isNeedPage: false,
                isFinished: true
            };
            Api.findHisTask(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.loading = false;
                    this.$log.error('/activitiDemo/findTask', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        applyQuery() {
            this.loading = true;
            this.columns = [
                {
                    prop: 'proInsId',
                    label: this.$t('pgCommon.WORK_FLOW_CODE'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'proDefKey',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFKEY'),
                    sortable: true
                },
                {
                    prop: 'proDefName',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFNAME'),
                    sortable: true
                },
                {
                    prop: 'currTaskKey',
                    label: this.$t('pgCommon.TASK_KEY'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'currTaskName',
                    label: this.$t('pgCommon.TASK_NAME'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnShowApply(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.CHECK')
                            )
                        ]);
                    }
                }
            ];
            let param = {
                applyUserId: sessionStorage.getItem('userId'),
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                isNeedPage: false
            };
            Api.findHisProcess(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.loading = false;
                    this.$log.error('/activitiDemo/findTask', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        invoQuery() {
            this.loading = true;
            this.columns = [
                {
                    prop: 'processId',
                    label: this.$t('pgCommon.WORK_FLOW_CODE'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'templateKey',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFKEY'),
                    sortable: true
                },
                {
                    prop: 'proDefName',
                    align: 'left',
                    label: this.$t('pgCommon.PRODEFNAME'),
                    sortable: true
                },
                {
                    prop: 'taskId',
                    align: 'left',
                    label: this.$t('pgCommon.TASK_ID'),
                    sortable: true
                },
                {
                    prop: 'taskKey',
                    label: this.$t('pgCommon.TASK_KEY'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: 'taskName',
                    label: this.$t('pgCommon.TASK_NAME'),
                    align: 'left',
                    sortable: true
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnShow(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.CHECK')
                            )
                        ]);
                    }
                }
            ];
            let param = {
                involvedUserId: sessionStorage.getItem('userId'),
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                isNeedPage: false
            };
            // 自定义封装前台输出日志方法
            // this.$log.info(param);
            Api.findHisTask(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.loading = false;
                    this.$log.error('/activitiDemo/findTask', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = this.$t('pgCommon.EDIT');
            // this.isAddData = false;
            this.dialogLeaveBillVisible = true;
            this.sIdDisabled = false;
            this.editDialog = true;
        },
        btnShow(row) {
            this.title = this.$t('pgCommon.CHECK');
            this.sIdDisabled = true;
            this.editItem = row;
            this.dialogLeaveBillVisible = true;
        },
        btnShowApply(row) {
            row.processId = row.proInsId;
            this.title = this.$t('pgCommon.CHECK');
            this.sIdDisabled = true;
            this.editItem = row;
            this.dialogLeaveBillVisible = true;
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryList();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryList();
        },
        // 关闭页面
        dialogLeaveBillClose() {
            this.dialogLeaveBillVisible = false;
            if (this.editDialog) {
                this.queryList();
                this.editDialog = false;
            }
        }
        // // 关闭页面
        // dialogLeaveBillPicClose() {
        //     this.dialogLeaveBillPicVisible = false;
        // }
    }
};
</script>
